import { api } from '@/api/api';
import { apis } from '@/config';
const performanceImpl = api.requireLogicalApi(apis.performanceImpl);
export const mailPerfTool = {
    mailList(stage, params) {
        const statKey = 'mail_list_load_time';
        const isThread = (params === null || params === void 0 ? void 0 : params.isThread) ? 'isThread' : 'noThread';
        const hasCache = (params === null || params === void 0 ? void 0 : params.noCache) ? 'noCache' : 'hasCache';
        const readStatus = (params === null || params === void 0 ? void 0 : params.read) !== undefined ? ((params === null || params === void 0 ? void 0 : params.read) ? 'read' : 'unread') : 'all';
        const redFlag = (params === null || params === void 0 ? void 0 : params.label0) !== undefined ? ((params === null || params === void 0 ? void 0 : params.label0) === 1 ? 'red' : 'notRed') : 'all';
        const statSubKey = `${isThread}_${hasCache}_${readStatus}_${redFlag}`;
        if (stage === 'start') {
            performanceImpl
                .time({
                statKey,
                statSubKey,
                params: {
                    start_index: (params === null || params === void 0 ? void 0 : params.startIndex) || 0,
                    folder: (params === null || params === void 0 ? void 0 : params.folder) || '',
                },
            })
                .catch();
        }
        else {
            setTimeout(() => {
                performanceImpl
                    .timeEnd({
                    statKey,
                    statSubKey,
                    params: { mail_count: (params === null || params === void 0 ? void 0 : params.count) || 0 },
                })
                    .catch();
            }, 0);
        }
    },
    mailContent(type, stage, params) {
        const statKey = `mail_content_${type}_load_time`;
        const isThread = (params === null || params === void 0 ? void 0 : params.isThread) ? 'isThread' : 'noThread';
        const statSubKey = `${isThread}`;
        if (stage === 'start') {
            performanceImpl.time({ statKey, statSubKey }).catch();
        }
        else {
            const perfParams = {
                mid: (params === null || params === void 0 ? void 0 : params.mid) || '',
                folder: (params === null || params === void 0 ? void 0 : params.folder) || '',
                read_status: (params === null || params === void 0 ? void 0 : params.read) !== undefined ? params === null || params === void 0 ? void 0 : params.read : false,
            };
            setTimeout(() => {
                performanceImpl.timeEnd({ statKey, statSubKey, params: perfParams }).catch();
            }, 0);
        }
    },
    writeMail(stage, params) {
        const statKey = 'mail_write_load_time';
        const writeType = (params === null || params === void 0 ? void 0 : params.writeType) || 'common';
        const statSubKey = `${writeType}`;
        if (stage === 'start') {
            performanceImpl.time({ statKey, statSubKey }).catch();
        }
        else {
            setTimeout(() => {
                performanceImpl.timeEnd({ statKey, statSubKey }).catch();
            }, 0);
        }
    },
    searchMail(searchType, stage, params) {
        const statKey = 'mail_search_load_time';
        const hasCache = params.noCache ? 'noCache' : 'hasCache';
        const folderType = params.fid ? 'singleFolder' : 'allFolder';
        const searchRange = params.searchRange === 'all' ? 'allItem' : 'singleItem';
        const statSubKey = searchType === 'advanced' ? `${searchType}_${hasCache}` : `${searchType}_${hasCache}_${folderType}_${searchRange}`;
        if (stage === 'start') {
            performanceImpl
                .time({
                statKey,
                statSubKey,
                params: {
                    search_word: params.searchWord || '',
                    search_range: params.searchRange,
                },
            })
                .catch();
        }
        else {
            setTimeout(() => {
                performanceImpl
                    .timeEnd({
                    statKey,
                    statSubKey,
                    params: {
                        mail_count: (params === null || params === void 0 ? void 0 : params.count) || 0,
                    },
                })
                    .catch();
            }, 0);
        }
    },
    attachmentTransfer(type, attachmentType, stage, params) {
        const statKey = `mail_attachment_${type}_time`;
        const statSubKey = `${attachmentType}`;
        if (stage === 'start') {
            performanceImpl.time({ statKey, statSubKey }).catch();
        }
        else {
            setTimeout(() => {
                if ((params === null || params === void 0 ? void 0 : params.fileSize) && (params === null || params === void 0 ? void 0 : params.fileSize) > 0) {
                    mailPerfTool
                        .attachmentSpeed(type, {
                        fileSize: params === null || params === void 0 ? void 0 : params.fileSize,
                        statKey,
                        statSubKey,
                    })
                        .then(() => {
                        const perfParams = {
                            file_size: (params === null || params === void 0 ? void 0 : params.fileSize) || 0,
                            file_type: (params === null || params === void 0 ? void 0 : params.fileType) || '',
                            result: (params === null || params === void 0 ? void 0 : params.result) || 'success',
                        };
                        performanceImpl.timeEnd({ statKey, statSubKey, params: perfParams }).catch();
                    });
                }
            }, 0);
        }
    },
    async attachmentSpeed(type, params) {
        const { statKey, statSubKey, fileSize } = params;
        const currentLogs = await performanceImpl.getTimerLog({ statKey, statSubKey });
        if (Array.isArray(currentLogs) && currentLogs.length > 0) {
            const currentLog = currentLogs.find(log => log.recording);
            if (currentLog) {
                const duration = Date.now() - currentLog.start;
                if (duration >= 0 && fileSize > 0) {
                    const accuracy = 100;
                    const speed = Math.round((fileSize / 1024 / (duration / 1000)) * accuracy) / 100;
                    performanceImpl
                        .point({
                        statKey: `mail_attachment_${type}_speed`,
                        statSubKey,
                        value: speed,
                        valueType: 5,
                    })
                        .catch();
                }
            }
        }
    },
    moveMail(type, stage, params) {
        const statKey = `mail_${type}_time`;
        const isThread = params.isThread ? 'isThread' : 'noThread';
        const statSubKey = `${isThread}`;
        if (stage === 'start') {
            performanceImpl
                .time({
                statKey,
                statSubKey,
            })
                .catch();
        }
        else {
            setTimeout(() => {
                performanceImpl
                    .timeEnd({
                    statKey,
                    statSubKey,
                    params: {
                        result: (params === null || params === void 0 ? void 0 : params.result) || 'success',
                    },
                })
                    .catch();
            }, 0);
        }
    },
};
